import { useState } from "react";
import {
  Box,
  Grid,
  GridItem,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Collapse,
  useBreakpointValue,
  Spacer,
  Flex,
  Icon,
  useColorModeValue,
  Tooltip,
  VStack,
  Popover,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  HStack,
  Input,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import DrawerSchedule from "components/Schedule/Drawer";
import useSchedule from "hooks/use-schedule";
import { format, isToday } from "date-fns";
import { BiDownload } from "react-icons/bi";
import { formatDateString, formatDateUs } from "helpers/formated";
import { PopoverTrigger } from "components/Chakra/Popover";
import useScheduleSupplier from "hooks/Supplier/use-schedule-supplier";
import DrawerSupplierSchedule from "components/Supplier/Schedule/Drawer";
import LoadingComponent from "components/Main/Loading";

interface CalendarProps {
  data: any;
  sector: string;
  date: any;
  getData: (start: any, end: any) => void;
}

const CalendarSupplierComponent: React.FC<CalendarProps> = ({
  data,
  sector,
  date,
  getData,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentDate, setCurrentDate] = useState(formatDateString(date));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEvent, setIsModalOpenEvent] = useState(false);
  const [isCollapseOpen, setIsCollapseOpen] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const { downloadExport, setScheduleSelect, loadingCalendar } =
    useScheduleSupplier();

  const handleStartDateChange = (e: { target: { value: any } }) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e: { target: { value: any } }) => {
    setEndDate(e.target.value);
  };

  const iconColor = useColorModeValue("brand.500", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  const [idSelect, setIdSelect] = useState(0);
  const abrirDrawer = (id?: number) => {
    setIdSelect(id);
    setIsOpenDrawer(true);
  };

  const fecharDrawer = () => {
    setIdSelect(0);
    setScheduleSelect([]);
    setIsOpenDrawer(false);
    setIsCollapseOpen(false);
  };
  const bgLoading = useColorModeValue("white", "#111C44");

  const handleDateClick = (date: Date) => {
    const clickedDateTimestamp = date.getTime();
    const selectedDateTimestamp = selectedDate.getTime();

    if (clickedDateTimestamp === selectedDateTimestamp) {
      setIsCollapseOpen(!isCollapseOpen); // Se a data for a mesma, fecha o colapso
    } else {
      setIsCollapseOpen(true); // Se a data for diferente, abre o colapso
    }
    setSelectedDate(date); // Atualiza a data selecionada
  };

  const handleDateClickEvent = (event: any) => {
    setSelectedEvent(event);
    // setIsCollapseOpen(!isCollapseOpen);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCloseModalEvent = () => {
    setIsModalOpenEvent(false);
  };

  const handleNextMonth = () => {
    getData(
      formatDateUs(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
      ),
      formatDateUs(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
      )
    );
    setCurrentDate((prevDate) => {
      return new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
    });
  };

  const handlePreviousMonth = () => {
    getData(
      formatDateUs(
        new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
      ),
      formatDateUs(
        new Date(currentDate.getFullYear(), currentDate.getMonth(), 0)
      )
    );
    setCurrentDate((prevDate) => {
      return new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
    });
  };
  const transformedArray = data.map((item: any) => ({
    date: new Date(item.schedulingDate),
    title: item.descriptionSupplier,
    id: item.deliverableGuid,
  }));

  const events = transformedArray;

  const hasEvent = (date: Date) => {
    return events.filter(
      (event: any) => event.date.toDateString() === date.toDateString()
    );
  };

  const capitalizeFirstLetter = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
  const days = Array.from(
    { length: daysInMonth },
    (_, index) => new Date(currentYear, currentMonth, index + 1)
  );

  const emptyDays = Array.from({ length: firstDayOfMonth }, (_, index) => (
    <GridItem key={`empty-${index}`} />
  ));
  const monthName = currentDate.toLocaleString("default", { month: "long" });
  const isWeekend = (date: Date) => {
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6;
  };

  const getBackgroundColor = (date: any) => {
    if (isToday(date)) {
      return "blue.300";
    } else if (isWeekend(date)) {
      return "gray.400";
    } else if (date.getMonth() === currentMonth) {
      return "gray.200";
    } else {
      return "gray.100";
    }
  };

  const getColorText = (date: any) => {
    if (isToday(date)) {
      return "white";
    } else if (isWeekend(date)) {
      return "white";
    } else if (date.getMonth() === currentMonth) {
      return "black";
    } else {
      return "white";
    }
  };

  //Export
  //Export

  const [startDate, setStartDate] = useState(format(days[0], "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(
    format(days[days.length - 1], "yyyy-MM-dd")
  );
  return (
    <>
      <Card flexDirection="column" p={4}>
        <DrawerSupplierSchedule
          id={idSelect}
          isOpen={isOpenDrawer}
          fecharDrawer={fecharDrawer}
        />

        <Flex justifyContent="space-between" alignItems="center" p={4}>
          <Text marginLeft="auto" mr={5} fontSize={28} fontWeight="700">
            {capitalizeFirstLetter(monthName)} - {currentYear}
          </Text>

          <Tooltip label="Clique aqui para Download !" placement="top">
            <Popover>
              <PopoverTrigger>
                <Button
                  ms="auto"
                  alignItems="center"
                  justifyContent="center"
                  bg={isMobile ? bgButton : bgButton}
                  _hover={bgHover}
                  _focus={bgFocus}
                  _active={bgFocus}
                  w="87px"
                  h="30px"
                  mt={2}
                  lineHeight="100%"
                  borderRadius="10px"
                >
                  {isMobile ? (
                    <>
                      <Icon
                        as={BiDownload}
                        color={iconColor}
                        w="24px"
                        h="24px"
                      />
                    </>
                  ) : (
                    <>
                      <Text color={iconColor} fontSize="12px">
                        Exportar
                      </Text>
                    </>
                  )}
                </Button>
              </PopoverTrigger>
              <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader>Exportar!</PopoverHeader>
                <PopoverBody>
                  Selecione o peridodo desejado
                  <Flex
                    flex={1}
                    mr={{ base: 0, md: 4 }}
                    mb={{ base: 4, md: 0 }}
                  >
                    <Text fontWeight={700}> Início: {"\u00a0"}</Text>
                    {"\u00a0"}
                    {"\u00a0"}
                    <Input
                      type="date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      bg="white"
                    />
                  </Flex>
                  <Flex
                    flex={1}
                    mr={{ base: 0, md: 4 }}
                    mb={{ base: 4, md: 0 }}
                  >
                    <Text fontWeight={700}>
                      Fim: {"\u00a0"}
                      {"\u00a0"}
                    </Text>
                    {"\u00a0"}
                    {"\u00a0"}
                    {"\u00a0"}
                    {"\u00a0"}
                    {"\u00a0"}
                    <Input
                      type="date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      bg="white"
                    />
                  </Flex>
                </PopoverBody>
                <PopoverFooter
                  border="0"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  pb={4}
                >
                  <Spacer />
                  <Button
                    background="green.300"
                    color="white"
                    onClick={() => {
                      downloadExport(startDate, endDate, sector);
                    }}
                    style={{ marginLeft: "auto" }}
                  >
                    Exportar
                  </Button>
                </PopoverFooter>
              </PopoverContent>
            </Popover>
          </Tooltip>

          <Spacer />
          {!isMobile && (
            <>
              <Flex>
                <Button
                  onClick={handlePreviousMonth}
                  colorScheme="green"
                  variant="outline"
                  mb={2}
                  flex="1"
                  fontSize={isMobile ? 12 : 18}
                >
                  {isMobile ? <>Anterior</> : <>Mês Anterior</>}
                </Button>

                <Button
                  ml={isMobile ? 1 : 4}
                  onClick={handleNextMonth}
                  colorScheme="green"
                  variant="outline"
                  mb={2}
                  flex="1"
                  fontSize={isMobile ? 12 : 18}
                >
                  {isMobile ? <>Próximo</> : <>Próximo Mês</>}
                </Button>
              </Flex>
            </>
          )}
        </Flex>
        {isMobile && (
          <>
            <Flex mb={4}>
              <Button
                onClick={handlePreviousMonth}
                colorScheme="green"
                size="sm"
                variant="outline"
                mb={2}
                flex="1"
                fontSize={isMobile ? 12 : 18}
              >
                {isMobile ? <>Anterior</> : <>Mês Anterior</>}
              </Button>

              <Button
                ml={isMobile ? 1 : 4}
                onClick={handleNextMonth}
                colorScheme="green"
                variant="outline"
                mb={2}
                size="sm"
                flex="1"
                fontSize={isMobile ? 12 : 18}
                padding={"4px"}
              >
                {isMobile ? <>Próximo</> : <>Próximo Mês</>}
              </Button>
            </Flex>
          </>
        )}
        {loadingCalendar ? (
          <>
            <Box bg={bgLoading}>
              <LoadingComponent spinnerSize="50vh" />
            </Box>
          </>
        ) : (
          <>
            <Grid templateColumns="repeat(7, 1fr)" gap={2}>
              <GridItem>
                <Text fontWeight="bold" textAlign="center">
                  Dom
                </Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold" textAlign="center">
                  Seg
                </Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold" textAlign="center">
                  Ter
                </Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold" textAlign="center">
                  Qua
                </Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold" textAlign="center">
                  Qui
                </Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold" textAlign="center">
                  Sex
                </Text>
              </GridItem>
              <GridItem>
                <Text fontWeight="bold" textAlign="center">
                  Sáb
                </Text>
              </GridItem>
              {emptyDays}
              {days.map((date) => (
                <GridItem key={date.toISOString()}>
                  <Box
                    p={2}
                    bg={getBackgroundColor(date)}
                    minH={isMobile ? 65 : 20}
                    minW={isMobile ? "30px" : "100px"}
                    borderRadius="5%"
                    border={
                      selectedDate?.toDateString() === date.toDateString()
                        ? "1px solid blue"
                        : "none"
                    }
                    onClick={() => {
                      hasEvent(date).length > 0 && handleDateClick(date);
                    }}
                    cursor="pointer"
                  >
                    <Text textAlign="center" color={getColorText(date)}>
                      {date.getDate()}
                    </Text>
                    <Text
                      mt={isMobile ? 2 : 5}
                      fontSize="sm"
                      color="blue.500"
                      textAlign="center"
                    >
                      {/* {event.title} */}
                      {hasEvent(date).length > 0 && (
                        <>
                          <Box
                            width="18px"
                            height="18px"
                            borderRadius="50%"
                            bg="red.500"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Text color="white" fontWeight="bold" fontSize="xs">
                              {hasEvent(date).length}
                            </Text>
                          </Box>
                        </>
                      )}
                    </Text>
                  </Box>
                  <Collapse
                    in={
                      selectedDate?.toDateString() === date.toDateString() &&
                      isCollapseOpen
                    }
                    animateOpacity
                  >
                    <Box
                      p={4}
                      mt={2}
                      width="20px"
                      height={
                        hasEvent(date).length < 6
                          ? 120
                          : hasEvent(date).length * 24
                      }
                    >
                      <Box
                        position="absolute"
                        bg="gray.400"
                        minW={isMobile ? "350px" : "850px"}
                        left={isMobile ? "20px" : "80px"}
                        borderRadius="1%"
                        p={2}
                      >
                        {hasEvent(date).map((event: any) => (
                          <HStack
                            cursor="pointer"
                            _hover={{
                              "& > *": {
                                textDecoration: "underline",
                                fontSize: "larger",
                              },
                            }}
                            onClick={() => {
                              handleDateClickEvent(event.title);
                              abrirDrawer(event.id);
                            }}
                          >
                            <Text
                              key={event.title}
                              fontSize="sm"
                              color="white"
                              cursor="pointer"
                              w="108px"
                              display="block"
                            >
                              ({event.id.split("-")[0].toUpperCase()}){" "}
                            </Text>
                            <Text
                              key={event.title}
                              fontSize="sm"
                              color="white"
                              cursor="pointer"
                              display="block"
                            >
                              {event.title}
                            </Text>
                          </HStack>
                        ))}
                      </Box>
                    </Box>
                  </Collapse>
                </GridItem>
              ))}
            </Grid>
          </>
        )}

        <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              {selectedDate && selectedDate.toDateString()}
            </ModalHeader>
            <ModalCloseButton color="white" />
            <ModalBody>{/* Conteúdo da modal */}</ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={handleCloseModal}>
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal isOpen={isModalOpenEvent} onClose={handleCloseModalEvent}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{selectedEvent}</ModalHeader>
            <ModalCloseButton color="white" />
            <ModalBody>{/* Conteúdo da modal */}</ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={handleCloseModalEvent}>
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Card>
    </>
  );
};

export default CalendarSupplierComponent;
